module.exports = __webpack_public_path__ + "static/img/logo.238dd107.png";